module.exports = __webpack_public_path__ + "img/读卡器一体机侧面.06657d6a.png";